import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  render() {
    const url = "https://young.tsnigri.ru/zip/";

    if (!this.props.data) return null;

    const video2023 = this.props.data.video2023.map(function (video2023) {
      return (
        <div key={video2023.name}>
          <p>
            <a href={`${video2023.link}`}>
              {video2023.name}
            </a>
            {video2023.description}
          </p>
        </div>
      );
    });

    const video2024 = this.props.data.video2024.map(function (video2024) {
      return (
        <div key={video2024.name}>
          <p>
            <a href={`${video2024.link}`} >
              {video2024.name}
            </a>
            {video2024.description}
          </p>
        </div>
      );
    });

    const video2025 = this.props.data.video2025.map(function (video2025) {
      return (
        <div key={video2025.name}>
          <p>
            <a href={`${video2025.link}`} >
              {video2025.name}
            </a>
            {video2025.description}
          </p>
        </div>
      );
    });

    const video2026 = this.props.data.video2026.map(function (video2026) {
      return (
        <div key={video2026.name}>
          <p>
            <a href={`${video2026.link}`} >
              {video2026.name}
            </a>
            {video2026.description}
          </p>
        </div>
      );
    });

    return (
      <section id="resume">
        <h1 style={{ textAlign: "center", fontSize: "38px" }}>Видеоматериалы</h1>
        <br />
        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>«Рудная школа (2023)»</span>
              </h1>
            </div>
            <div className="nine columns main-col">{video2023}</div>
            <div className="nine columns main-col">
              {/*<a href="/#" download="video2023">
                Скачать архив
              </a>*/}
            </div>
          </div>
        </Slide>
        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>«Рудная школа (2024)»</span>
              </h1>
            </div>
            <div className="nine columns main-col">{video2024}</div>
            <div className="nine columns main-col">
              {/* <a href="/#" download="video2024">
                Скачать архив
              </a> */}
            </div>
          </div>
        </Slide>
        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>«Рудная школа (2025)»</span>
              </h1>
            </div>
            <div className="nine columns main-col">{video2025}</div>
            <div className="nine columns main-col">
              {/* <a href="/#" download="video2025">
                Скачать архив
              </a> */}
            </div>
          </div>
        </Slide>
        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>«Рудная школа (2026)»</span>
              </h1>
            </div>
            <div className="nine columns main-col">{video2026}</div>
            <div className="nine columns main-col">
              {/* <a href="/#" download="video2026">
                Скачать архив
              </a> */}
            </div>
          </div>
        </Slide>
      </section>
    );
  }
}

export default Resume;

